module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("10CYl"))).then(() => parcelRequire('d0iPb'));